import { Select } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTraegerList } from '@/api/useTraeger';
import { useAppStore } from '@/store/appStore';
import { useTraegerAccess } from '@/auth/useTraegerAccess';

export function MandantSwitcher() {
  const { t } = useTranslation('common');
  const { data, isLoading, isError } = useTraegerList();
  const activeId = useAppStore((s) => s.activeTraegerId);
  const setTraeger = useAppStore((s) => s.setTraeger);
  const { hasAccess } = useTraegerAccess();

  const options = useMemo(() => {
    if (!data) return [];
    return data
      .filter((tr) => hasAccess(tr.id))
      .map((tr) => ({ value: tr.id, label: tr.name }));
  }, [data, hasAccess]);

  return (
    <Select
      label={t('header.mandant')}
      placeholder={isLoading ? t('state.loading') : t('header.mandant')}
      data={options}
      value={activeId}
      onChange={setTraeger}
      disabled={isLoading || isError}
      searchable
      nothingFoundMessage={t('state.empty')}
      w={200}
      aria-label={t('header.mandant')}
    />
  );
}
